import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@progress/kendo-angular-l10n';
import { AppSettings } from '../core/common/app.settings';
import { Language } from '../core/contracts';

@Injectable({
  providedIn: 'root',
})
export class CustomKendoMessageService extends MessageService {
  constructor(private translate: TranslateService) {
    super();
    this.translate.onLangChange.subscribe(event => {
      const languageCode = event.lang.substring(0, 2).toLowerCase();
      const language = Language[languageCode as keyof typeof Language];
      this.notify(AppSettings.isRtlLanguage(language));
    });
  }
}
